<div class="container-fluid bg-white vh-100 p-0">
    <ClientLogo v-if="this.$route.name != 'behalf_application'" />
    <BreadCrumb label="Trust Trustees Search" />
    <div class="d-flex justify-content-center align-items-center min-vh-50">
        <div class="col-11 col-sm-10 col-md-8 col-lg-6 col-xl-5 p-3">
            <div class="form-group mt-3">
                <form @submit.prevent="submit_trust_trustees">
                    <div class="row">
                        <div class="form-group col-sm-12 mt-3">
                            <label for="trust_number" class="fw-bold text-xs">Trust Number</label>
                            <input type="text" v-model="form.trust_number" class="form-control text-xs rounded-small p-3 shadow-sm" id="trust_number" placeholder="000000/YYYY" required>
                        </div>
                        <div class="form-group col-sm-12 mt-3">
                            <label for="masters_office" class="fw-bold text-xs">Master's Office</label>
                            <input type="text" v-model="form.masters_office" class="form-control text-xs rounded-small p-3 shadow-sm" id="masters_office" required placeholder="eg. Bloemfontein">
                        </div>
                    </div>
                    <div class="d-flex justify-content-center mb-3 mt-4">
                        <button type="submit" class="btn btn-bg-green btn-sm px-4 rounded-small shadow-sm fw-bold text-xs">
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>